import { DealStatus } from '../../enum/DealStatus';

export const dealStatusOptions = [
  { title: 'Priced', value: DealStatus.Priced },
  { title: 'Upcoming', value: DealStatus.Upcoming },
];
